import axios from 'axios';
import React, { useEffect, useState } from 'react'
import Modal from 'react-bootstrap/Modal';
import Select from 'react-select';
import ReportIcon from '@mui/icons-material/Report';
import { usePapaParse } from 'react-papaparse';
import { useCSVDownloader } from 'react-papaparse';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'

function UserSetup({ serverUrl, user, titleOfPage, globalUserId, globalToken   }) {
    const { jsonToCSV } = usePapaParse();
    const { CSVDownloader, Type } = useCSVDownloader();


    const [viewAddUser, setViewAddUser] = useState(false)
    const [viewEditUser, setViewEditUser] = useState(false)
    const [userViewMode, setUserViewMode] = useState(false)
    const [changePasswordView, setChangePasswordView] = useState(false)

    const [username, setUsername] = useState("")
    const [password, setPassword] = useState("")
    const [designation, setDesignation] = useState("Admin")
    const [permissions, setPermissions] = useState(null)
    const [details, setDetails] = useState("")
    const [editUserData, setEditUserData] = useState({});
    const [allUsers, setAllUsers] = useState([]);


    const [passwordCurrent, setPasswordCurrent] = useState("");
    const [passwordNew, setPasswordNew] = useState("");
    const [passwordNewVerify, setPasswordNewVerify] = useState("");

    const [registrationResults, setRegistrationResults] = useState("");


    const [formattedUsersForExport, setFormattedUsersForExport] = useState([])

    const [loadingUserDetails, setLoadingUserDetails] = useState(false);


    const resetAllFields = () => {
        setUsername("")
        setPassword("")
        setDesignation("")
        setPermissions(null)
        setDetails("")
        setRegistrationResults(null);
        setEditUserData({})
        setPasswordCurrent("")
        setPasswordNew("")
        setPasswordNewVerify("")
    }

    const editUser = async (e) => {
        e.preventDefault();
        // console.log(editUserData.userId)
        const query = {
            "sourceUserId": editUserData.userId,
            "name": username,
            "email": username,
            "userId": username,
            "userType": designation,
            "designation": designation,
            "details": details,
            "permissions": permissions,
        }

        const editUser = await axios.post(serverUrl + "/users/edit", query);
        if (editUser.status == 200) {
            delete editUserData.logs
            delete editUserData.notifications
            delete editUserData.updatedAt
            delete editUserData.createdAt
            delete editUserData._id
            delete editUserData.__v
            query["previousData"] = editUserData
            updateLog({ "Name": "User Edited", "User ID": username, "Details": query })

            // console.log(editUser.data)
            setViewEditUser(false);
            resetAllFields()
            setEditUserData({})
            getAllUsers()
        } else {
            console.log(editUser.data)
            setRegistrationResults({ "status": "failed", "data": editUser.data })
        }
    }
    const addUser = async (e) => {
        e.preventDefault();

        const query = {
            "name": username,
            "email": username,
            "password": password,
            "userId": username,
            "userType": designation,
            "designation": designation,
            "details": details,
            "permissions": permissions,
            "notifications": [],
            "logs": [],
            "picture": "",
            "settings": {}
        }

        const addUser = await axios.post(serverUrl + "/users/register", query);
        if (addUser.status == 200) {
            // console.log(addUser.data)

            updateLog({ "Name": "New User Added", "User ID": username, "Details": query })

            setViewAddUser(false);
            resetAllFields()
            getAllUsers();
        } else {
            // console.log(addUser.data)
            setRegistrationResults({ "status": "failed", "data": addUser.data })
        }
    }

    const checkPassword = async (e) => {
        e.preventDefault()
        const query = {
            "userId": editUserData.userId,
            "oldPassword": passwordCurrent,
            "newPassword": passwordNew,
            "newPasswordVerify": passwordNewVerify,
        }

        if (passwordNew === passwordNewVerify) {
            // console.log(query)
            const updatePassword = await axios.post(serverUrl + "/users/checkPassword", query);

            if (updatePassword.status == 200) {
                delete editUserData.logs
                delete editUserData.notifications
                delete editUserData.updatedAt
                delete editUserData.createdAt
                delete editUserData._id
                delete editUserData.__v
                query["previousData"] = editUserData
                updateLog({ "Name": "Password Changed", "User ID": editUserData.userId, "Details": query })
                alert("Password Changed")
                setChangePasswordView(false);
                resetAllFields()
                getAllUsers()
            } else {
                alert("Wrong Password")
            }
        } else {
            alert("Password didn't match")
        }
    }


    const getAllUsers = async () => {
        const getUserNow = await axios.post(serverUrl + "/users/getAllUsers")

        if (getUserNow.status == 200) {
            // console.log(getUserNow.data)
            setAllUsers(getUserNow.data)

            let allUsersFormated = [];
            getUserNow.data.map((data, key) => {
                data.notifications = JSON.stringify(data.notifications)
                data.logs = JSON.stringify(data.logs)
                data.permissions = JSON.stringify(data.permissions)
                data.settings = JSON.stringify(data.settings)
                return allUsersFormated.push(data)
            })
            setFormattedUsersForExport(allUsersFormated)


        } else {
            console.log(getUserNow.data)
        }
    }


    const getUserDetails = async (userId) => {
        setLoadingUserDetails(true)
        const query = { "userId": userId }
        const getUserNow = await axios.post(serverUrl + "/users/find", query)

        if (getUserNow.status == 200) {
            // console.log(getUserNow.data[0])
            setEditUserData(getUserNow.data[0]);

            setUsername(getUserNow.data[0].userId)
            setDesignation(getUserNow.data[0].designation)
            setPermissions(getUserNow.data[0].permissions)
            setDetails(getUserNow.data[0].details)

            setLoadingUserDetails(false);
        } else {
            console.log(getUserNow.data)
        }
    }

    const updateLog = async (data) => {
        const dataSet = {
            "userId": user.userId,
            "changes": data,
        }
        const updateNow = await axios.post(serverUrl + "/users/updateLog", dataSet)
        if (updateNow.status == 200) {
            console.log(updateNow.data)
        } else {
            console.log(updateNow.data)
        }
    }

    useEffect(() => {
        getAllUsers()
    }, [])

    return (
        <>
            <div className='h-100 w-100 dataTableSet d-flex flex-column overflow-auto'>
                <div className='w-100 upperMoonsSearchBackground themeTextColor border-0 fs-4 p-0 shadow-sm text-center'>{titleOfPage}</div>
                <div className='p-2 p-md-3 p-lg-3 overflow-auto d-flex flex-column rounded-0 h-100'>
                    <div className='mb-3 d-flex gap-3 justify-content-between flex-wrap'>
                        <div className='d-flex gap-5 flex-wrap'>
                            <button className='themeButtons px-4 py-2 rounded-pill fw-bold' onClick={(e) => {
                                setViewAddUser(true);
                                setUserViewMode("New")
                            }}>Add User</button>
                        </div>
                        <div className='d-flex gap-5 flex-wrap'>
                            <CSVDownloader
                                type={Type.Button}
                                filename={'Users'}
                                bom={true}
                                config={{
                                    delimiter: ',',
                                }}
                                className="btn btn-success px-4 py-2 rounded-pill fw-bold"
                                data={
                                    jsonToCSV(formattedUsersForExport)
                                }
                            >
                                Export to Excel
                            </CSVDownloader>
                        </div>
                    </div>
                    <div className="themeTextColor fs-5 my-3 fw-bold d-flex gap-1">
                        <span>
                            Total Records:
                        </span>
                        {
                            allUsers.length > 0 ?
                                allUsers.length
                                :
                                "0"
                        }
                    </div>
                    <div className='overflow-auto'>
                        <table className='table table-light table-bordered w-100 table-striped pb-5 text-center m-0'>
                            <thead className=''>
                                <tr align="center" className='sticky-top'>
                                    <th>#</th>
                                    <th>User Type</th>
                                    <th>User Details</th>
                                    <th width="1%">Option</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    allUsers.length > 0 ?
                                        allUsers.map((data, key) => {
                                            return (
                                                <tr key={key}>
                                                    <td>{key + 1}</td>
                                                    <td>{data.userId}</td>
                                                    <td>{data.details}</td>
                                                    <td valign='middle'>
                                                        <div className='d-flex gap-2 align-items-center'>
                                                            <button className='themeButtons px-3 py-1 rounded w-100' style={{ minWidth: "50px", maxWidth: "100px" }} onClick={() => { setViewEditUser(true); getUserDetails(data.userId); }}>Edit</button>
                                                            <button className='themeButtons px-3 py-1 rounded w-100 text-nowrap' style={{ minWidth: "min-content" }} onClick={(e) => {
                                                                setChangePasswordView(true);
                                                                getUserDetails(data.userId);
                                                            }}>Change Password</button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        })
                                        :
                                        <tr>
                                            <td valign='middle' colSpan={4}>
                                                <div className="upperMoonsSearchBackground p-2 themeTextColor fw-bold">
                                                    No Data
                                                </div>
                                            </td>
                                        </tr>
                                }

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>




            {/* New User View */}

            <Modal
                show={viewAddUser}
                onHide={() => { setViewAddUser(false); resetAllFields(); }}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered>
                <form action="" onSubmit={(e) => { addUser(e) }}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <span className='themeTextColor'>New User</span>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="container-fluid">
                            <div className="row align-items-center justify-content-center">
                                <div className="col-12 d-flex align-items-center justify-content-center mb-3">
                                    <input type="text" className='customFieldForDence w-100' placeholder='Username' required value={username} onInput={(e) => { setUsername(e.target.value) }} style={{ maxWidth: "300px" }} />
                                </div>
                                <div className="col-12 d-flex align-items-center justify-content-center mb-3">
                                    <input type="password" className='customFieldForDence w-100' placeholder='Password' required value={password} onInput={(e) => { setPassword(e.target.value) }} style={{ maxWidth: "300px" }} />
                                </div>
                                <div className="col-12 d-flex align-items-center justify-content-center mb-3">
                                    <select className='customFieldForDence themeTextColor' defaultValue={designation} onInput={(e) => { setDesignation(e.target.value) }} style={{ maxWidth: "300px" }}>
                                        <option value="Admin">Admin</option>
                                        <option value="Employee">Employee</option>
                                        <option value="Labs">Labs</option>
                                        <option value="Super Admin">Super Admin</option>
                                        <option value="User">User</option>
                                    </select>
                                </div>
                                <div className="col-12 d-flex align-items-center justify-content-center mb-3">
                                    <div className='d-flex flex-column align-items-start justify-content-center w-100' style={{ maxWidth: "300px" }}>
                                        <label htmlFor="" className='themeTextColor fs-6'>
                                            Permissions:
                                        </label>
                                        <Select
                                            className='w-100'
                                            placeholder="Permission"
                                            value={permissions}
                                            onChange={setPermissions}
                                            autoFocus={false}
                                            isMulti={true}
                                            isSearchable={true}
                                            required={true}
                                            options={[
                                                { value: 'Registration of Lab', label: 'Registration of Lab' },
                                                { value: 'Edit', label: 'Edit' },
                                                { value: 'Create', label: 'Create' },
                                                { value: 'Upload', label: 'Upload' },
                                                { value: 'Generate', label: 'Generate' },
                                                { value: 'Export', label: 'Export' },
                                                { value: 'Assign', label: 'Assign' },
                                            ]}
                                        />
                                    </div>
                                </div>
                                <div className="col-12 d-flex align-items-center justify-content-center">
                                    <textarea className='customFieldForDence w-100' style={{ maxWidth: "300px" }} placeholder='Details' value={details} onInput={(e) => { setDetails(e.target.value) }}></textarea>
                                </div>
                                {
                                    registrationResults ?
                                        <div className="col-12 d-flex align-items-center justify-content-center mt-3">
                                            <div className={`alert ${registrationResults.status === "failed" ? "alert-danger" : "alert-success"} p-2 text-center w-100 shadow-sm d-flex align-items-center justify-content-center gap-1`}>
                                                <ReportIcon />
                                                {
                                                    registrationResults.status === "failed" ?
                                                        registrationResults.data
                                                        :
                                                        "User Registered Successfully"
                                                }
                                            </div>
                                        </div>
                                        :
                                        ""
                                }
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className='w-100 d-flex justify-content-center'>
                            <input type="submit" value="Save User" className='themeButtons rounded-pill px-5 py-2 fw-bold' />
                        </div>
                    </Modal.Footer>
                </form>
            </Modal>





            {/* Edit User View */}
            <Modal
                show={viewEditUser}
                onHide={() => { setViewEditUser(false); resetAllFields(); }}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered>
                <form action="" onSubmit={(e) => { editUser(e) }}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <span className='themeTextColor'>Edit User</span>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {
                            !loadingUserDetails ?
                                <div className="container-fluid">
                                    <div className="row align-items-center justify-content-center">
                                        <div className="col-12 d-flex align-items-center justify-content-center mb-3">
                                            <input type="text" className='customFieldForDence w-100' placeholder='Username' required value={username} onInput={(e) => { setUsername(e.target.value) }} style={{ maxWidth: "300px" }} />
                                        </div>
                                        <div className="col-12 d-flex align-items-center justify-content-center mb-3">
                                            <select className='customFieldForDence themeTextColor' value={designation} onInput={(e) => { setDesignation(e.target.value) }} style={{ maxWidth: "300px" }}>
                                                <option value="Admin">Admin</option>
                                                <option value="Employee">Employee</option>
                                                <option value="Labs">Labs</option>
                                                <option value="Super Admin">Super Admin</option>
                                                <option value="User">User</option>
                                            </select>
                                        </div>
                                        <div className="col-12 d-flex align-items-center justify-content-center mb-3">
                                            <div className='d-flex flex-column align-items-start justify-content-center w-100' style={{ maxWidth: "300px" }}>
                                                <label htmlFor="" className='themeTextColor fs-6'>
                                                    Permissions:
                                                </label>
                                                <Select
                                                    className='w-100'
                                                    placeholder="Permission"
                                                    value={permissions}
                                                    onChange={setPermissions}
                                                    autoFocus={false}
                                                    isMulti={true}
                                                    isSearchable={true}
                                                    required={true}
                                                    options={[
                                                        { value: 'Registration of Lab', label: 'Registration of Lab' },
                                                        { value: 'Edit', label: 'Edit' },
                                                        { value: 'Create', label: 'Create' },
                                                        { value: 'Upload', label: 'Upload' },
                                                        { value: 'Generate', label: 'Generate' },
                                                        { value: 'Export', label: 'Export' },
                                                        { value: 'Assign', label: 'Assign' },
                                                    ]}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-12 d-flex align-items-center justify-content-center">
                                            <textarea className='customFieldForDence w-100' style={{ maxWidth: "300px" }} placeholder='Details' value={details} onInput={(e) => { setDetails(e.target.value) }}></textarea>
                                        </div>
                                        {
                                            registrationResults ?
                                                <div className="col-12 d-flex align-items-center justify-content-center mt-3">
                                                    <div className={`alert ${registrationResults.status === "failed" ? "alert-danger" : "alert-success"} p-2 text-center w-100 shadow-sm d-flex align-items-center justify-content-center gap-1`}>
                                                        <ReportIcon />
                                                        {registrationResults.data}
                                                    </div>
                                                </div>
                                                :
                                                ""
                                        }
                                    </div>
                                    <div className="row">
                                        <div className="col">

                                        </div>
                                    </div>
                                </div>
                                :
                                <SkeletonTheme highlightColor='#d8733934'>
                                    <Skeleton height={35} style={{ marginBottom: "10px" }} />
                                    <Skeleton height={35} style={{ marginBottom: "10px" }} />
                                    <Skeleton height={120} style={{ marginBottom: "10px" }} />
                                    <Skeleton height={60} style={{ marginBottom: "10px" }} />
                                </SkeletonTheme>
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        <div className='w-100 d-flex justify-content-center'>
                            <input type="submit" value="Update" className='themeButtons rounded-pill px-5 py-2 fw-bold' />
                        </div>
                    </Modal.Footer>
                </form>
            </Modal>







            {/* Change Password View */}

            <Modal
                show={changePasswordView}
                onHide={() => { setChangePasswordView(false) }}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered>
                <form action="" onSubmit={(e) => { checkPassword(e) }}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <span className='themeTextColor'>
                                Change Password
                            </span>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12 mb-3">
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-12 d-flex justify-content-center">
                                                <input type="password" placeholder='Current Password' required className='customFieldForDence w-100' value={passwordCurrent} onInput={(e) => { setPasswordCurrent(e.target.value) }} style={{ maxWidth: "300px" }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 mb-3">
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-12 d-flex justify-content-center">
                                                <input type="password" placeholder='New Password' required className='customFieldForDence w-100' value={passwordNew} onInput={(e) => { setPasswordNew(e.target.value) }} style={{ maxWidth: "300px" }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-12 d-flex justify-content-center">
                                                <input type="password" placeholder='Verify Password' required className='customFieldForDence w-100' value={passwordNewVerify} onInput={(e) => { setPasswordNewVerify(e.target.value) }} style={{ maxWidth: "300px" }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className='w-100 d-flex justify-content-center'>
                            <input type="submit" value="Change" className='themeButtons rounded-pill px-5 py-2 fw-bold' />
                        </div>
                    </Modal.Footer>
                </form>
            </Modal>
        </>
    )
}

export default UserSetup